function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//

import * as React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet, font, fontWeight, fontFamily, color } from "../../styles/theme";
import withHashId from "../hoc/withHashId";
import { SvgEdit } from "../../svg";
var STYLE = {
  height: 48,
  minWidth: 300,
  borderWidth: 1
};
var styles = StyleSheet.create({
  TextInput: {
    'width': '100%',
    'font-family': fontFamily.body,
    'min-width': STYLE.minWidth
  },
  label: {
    'font-size': font.sm,
    'text-transform': 'uppercase',
    'font-weight': fontWeight.bold,
    'margin-right': '0.75rem'
  },
  inputWrapper: {
    'display': 'flex',
    'align-items': 'center'
  },
  input: {
    'width': '100%',
    'height': STYLE.height,
    'padding': '0.75rem',
    'font-size': font.md,
    'border': "".concat(STYLE.borderWidth, "px solid ").concat(color.darkGray),
    'background-color': color.white,
    'color': color.primaryText,
    ':focus': {
      'border-color': color.primary,
      'outline': 'none'
    },
    ':disabled': {
      'background-color': color.disabled
    }
  },
  inputWithEditIcon: {
    'width': 'calc(100% - 30px)',
    'margin-right': '4px'
  },
  subLabel: {
    'font-size': font.sm,
    'color': color.secondaryText,
    'marginBottom': '0.5rem'
  },
  error: {
    'font-size': font.sm
  },
  errorText: {
    color: color.danger
  },
  errorOutline: {
    'border-color': color.danger,
    ':focus': {
      'border-color': color.danger
    }
  },
  explanatoryText: {
    'font-size': font.md,
    'color': color.secondaryText
  },
  explanatoryTextSpacingBottom: {
    'margin-bottom': '0.75rem'
  },
  explanatoryTextSpacingTop: {
    'margin-top': '0.75rem'
  }
});
var TextInput = /*#__PURE__*/function (_React$Component) {
  function TextInput() {
    var _this;
    _classCallCheck(this, TextInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TextInput, [].concat(args));
    _defineProperty(_this, "state", {
      showIcon: false
    });
    _defineProperty(_this, "handleMouseOver", function () {
      var useEditIcon = _this.props.useEditIcon;
      if (useEditIcon) _this.setState({
        showIcon: true
      });
    });
    _defineProperty(_this, "handleMouseOut", function () {
      var useEditIcon = _this.props.useEditIcon;
      if (useEditIcon) _this.setState({
        showIcon: false
      });
    });
    return _this;
  }
  _inherits(TextInput, _React$Component);
  return _createClass(TextInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _refAlt = _this$props._refAlt,
        componentId = _this$props.componentId,
        disabled = _this$props.disabled,
        error = _this$props.error,
        explanatoryText = _this$props.explanatoryText,
        explanatoryTextPosition = _this$props.explanatoryTextPosition,
        hideLabel = _this$props.hideLabel,
        htmlAttributes = _this$props.htmlAttributes,
        label = _this$props.label,
        name = _this$props.name,
        _this$props$nativeHtm = _this$props.nativeHtmlAttributes,
        nativeHtmlAttributes = _this$props$nativeHtm === void 0 ? {} : _this$props$nativeHtm,
        onBlur = _this$props.onBlur,
        onFocus = _this$props.onFocus,
        onChange = _this$props.onChange,
        placeholder = _this$props.placeholder,
        style = _this$props.style,
        subLabel = _this$props.subLabel,
        type = _this$props.type,
        value = _this$props.value,
        required = _this$props.required,
        useEditIcon = _this$props.useEditIcon;
      var showIcon = this.state.showIcon;
      var _labelId = "".concat(componentId, "-label");
      var _inputId = "".concat(componentId, "-input");
      return /*#__PURE__*/React.createElement("div", _extends({}, htmlAttributes, css(styles.TextInput), {
        style: style,
        "aria-describedby": _labelId
      }), /*#__PURE__*/React.createElement("div", null, label && /*#__PURE__*/React.createElement("label", _extends({}, css(hideLabel && 'sr-only', styles.label, error && styles.errorText), {
        id: _labelId,
        htmlFor: _inputId
      }), label), !error && subLabel && /*#__PURE__*/React.createElement("span", css(styles.subLabel), subLabel), error && /*#__PURE__*/React.createElement("span", css(styles.subLabel, styles.errorText), error)), explanatoryText && explanatoryTextPosition === 'before-input' && /*#__PURE__*/React.createElement("div", css(styles.explanatoryText, styles.explanatoryTextSpacingBottom), explanatoryText), /*#__PURE__*/React.createElement("div", _extends({
        onMouseOverCapture: this.handleMouseOver,
        onMouseOutCapture: this.handleMouseOut
      }, css(styles.inputWrapper)), /*#__PURE__*/React.createElement("input", _extends({}, css(styles.input, error ? styles.errorOutline : '', useEditIcon ? styles.inputWithEditIcon : ''), {
        "aria-label": label,
        "aria-labelledby": _labelId,
        "aria-invalid": !!error,
        "aria-required": required,
        disabled: disabled,
        id: _inputId,
        name: name,
        onFocus: onFocus,
        onBlur: onBlur,
        onChange: onChange,
        placeholder: placeholder,
        ref: _refAlt,
        type: type,
        value: value
      }, nativeHtmlAttributes)), useEditIcon && showIcon && /*#__PURE__*/React.createElement(SvgEdit, {
        color: color.primary
      })), explanatoryText && explanatoryTextPosition === 'after-input' && /*#__PURE__*/React.createElement("div", css(styles.explanatoryText, styles.explanatoryTextSpacingTop), explanatoryText));
    }
  }]);
}(React.Component);
_defineProperty(TextInput, "defaultProps", {
  type: 'text',
  label: '',
  placeholder: '',
  error: false,
  useEditIcon: false
});
TextInput.propTypes = {
  componentId: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  subLabel: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  explanatoryText: PropTypes.string,
  explanatoryTextPosition: PropTypes.oneOf(['before-input', 'after-input']),
  onBlur: PropTypes.func,
  style: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  htmlAttributes: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  nativeHtmlAttributes: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  /**
   * Dom ref for input
   */
  _refAlt: PropTypes.func
};
export default TextInput;
export var TextInputWithHashId = withHashId()(TextInput);